import smoothscroll from 'smoothscroll-polyfill';

if (process.browser) {
  smoothscroll.polyfill();
}